import LoadingButton from '@/common/components/base/button/loadingButton';
import DateInput from '@/common/components/base/input/dateInput/DateInput';
import RadioGroup from '@/common/components/base/input/radioGroup/RadioGroup';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import {
  ONLY_NUMBERS_RULE,
  PERSIAN_LATTER_RULE,
} from '@/common/components/base/input/textInput/textInput.rules';
import { NATIONAL_CODE_RULE } from '@/common/utils/rules/nationalCode.rules';
import { requiredText } from '@/common/utils/rules/publicRules';
import { ADJUSTER_REPORT_DAMAGED_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';
import { validateNotFutureDate } from '@/modules/adjusterReportModules/IncidentDetails/utils/incidentDetails.util';
import PersonalInquiry from '@/modules/adjusterReportModules/IncidentParticipants/components/common/personalInquiry/PersonalInquiry';
import { DriverInfoType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDriverInfo/driverInfoQuery.type';
import { useDriverPersonalInfoQuery } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchPersonalDriverData/driverPersonalInfoQueryOptions';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';

const InitialDataDriver: React.FC = () => {
  const methods = useFormContext<DriverInfoType>();
  const { id, damagedId } = useParams();
  const navigate = useNavigate();
  const { mutate: sendPersonalDriverData, isPending: loading } =
    useDriverPersonalInfoQuery();
  const onSubmit = (formData: DriverInfoType) => {
    sendPersonalDriverData(
      {
        data: {
          ...formData.personal_information,
          father_name: formData?.personal_information?.father_name || null,
        },
        damaged_id: Number(damagedId),
        id: Number(id),
      },
      {
        onSuccess: () => {
          navigate(
            ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_INFORMATION({
              damagedId: +damagedId!,
              id: +id!,
            }).DRIVER_OWNER_INFORMATION.certificate,
            { replace: true },
          );
        },
      },
    );
  };
  return (
    <Flex direction="column" gap={32} mb={24}>
      <Box py={24}>
        <PersonalInquiry outSideForm={useFormContext} />
      </Box>
      <RadioGroup
        title="جنسیت راننده"
        name="personal_information.gender"
        options={[
          { label: 'آقا', value: 'male' },
          { label: 'خانم', value: 'female' },
        ]}
        renderRadioButton={(Component) => <Box>{Component}</Box>}
        className={css({ gap: '2rem' })}
      />

      <Box>
        <TextInput
          label="نام"
          name="personal_information.first_name"
          placeholder="نام را وارد کنید"
          rules={{ required: requiredText, ...PERSIAN_LATTER_RULE }}
          defaultValue=""
        />
      </Box>
      <Box>
        <TextInput
          label="نام ‌خانوادگی"
          name="personal_information.last_name"
          placeholder="نام ‌خانوادگی را وارد کنید"
          rules={{ required: requiredText, ...PERSIAN_LATTER_RULE }}
          defaultValue=""
        />
      </Box>
      <Box>
        <DateInput
          label="تاریخ تولد"
          name="personal_information.birthdate"
          buttonText="انتخاب تاریخ"
          modalLabel="انتخاب تاریخ تولد"
          defaultValue=""
          rules={{ validate: validateNotFutureDate, required: requiredText }}
        />
      </Box>

      <RadioGroup
        title="تابعیت"
        name="personal_information.driver_iranian"
        options={[
          { label: 'ایرانی', value: 'true' },
          { label: 'غیر ایرانی', value: 'false' },
        ]}
        renderRadioButton={(Component) => <Box>{Component}</Box>}
        className={css({ gap: '2rem' })}
      />

      <Box>
        <TextInput
          label="کدملی"
          name="personal_information.national_code"
          placeholder="کدملی را وارد کنید"
          defaultValue=""
          rules={{
            required: requiredText,
            ...ONLY_NUMBERS_RULE,
            ...NATIONAL_CODE_RULE,
          }}
          max={10}
        />
      </Box>
      <Box>
        <TextInput
          label="نام پدر"
          name="personal_information.father_name"
          placeholder="نام پدر را وارد کنید"
          defaultValue=""
          optionalLabel
        />
      </Box>
      <Box>
        <TextInput
          label="شماره شناسنامه"
          name="personal_information.identity_number"
          placeholder="شماره شناسنامه را وارد کنید"
          rules={{ ...ONLY_NUMBERS_RULE, required: requiredText }}
          defaultValue=""
          noCharInput
          max={10}
        />
      </Box>
      <Box>
        <TextInput
          label="محل صدور شناسنامه"
          name="personal_information.identity_issue_location"
          placeholder="محل صدور شناسنامه را وارد کنید"
          rules={{ ...PERSIAN_LATTER_RULE, required: requiredText }}
          defaultValue=""
        />
      </Box>

      <RadioGroup
        title="آیا راننده مالک وسیله‌نقلیه است ؟"
        name="personal_information.is_owner_driver"
        options={[
          { label: 'بله', value: 'true' },
          { label: 'خیر', value: 'false' },
        ]}
        renderRadioButton={(Component) => <Box>{Component}</Box>}
        className={css({ gap: '2rem' })}
      />

      <Box w="100%">
        <LoadingButton
          onClick={methods.handleSubmit(onSubmit)}
          loading={loading}
          fullWidth
          disabled={!methods?.formState?.isValid}
        >
          ثبت و ادامه
        </LoadingButton>
      </Box>
    </Flex>
  );
};
export default InitialDataDriver;
